module.exports = __webpack_public_path__ + "static/media/image-variant.8305d01e.png";